import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

// Reactstrap components
import {
    Button,
    Card,
    CardHeader,
    CardBody,
    FormGroup,
    Row,
    Col,
} from 'reactstrap';

// Import multi-select checkboxes
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { db } from 'MY_LOGIN_AND_SIGNUP/db/config';
import firebase from 'firebase';

function EditTeacher({ onClick, setUserData, notify, teacherId, getUsers }) {
    const { register, handleSubmit, setValue, getValues, errors } = useForm();
    const [batchList, setBatchList] = useState([]);
    const [showPassword, setShowPassword] = useState(false);
    const [selectedBatches, setSelectedBatches] = useState([]);

    const teacherPermissions = [
        { label: 'Book Management', value: 'Book_Management' },
        { label: 'Mock Management', value: 'Quiz_Management' },
        { label: 'Batch Management', value: 'Batch_Management' },
        { label: 'Session Management', value: 'Session_Management' },
        { label: 'Subject Management', value: 'Subject_Management' },
    ];

    // Fetch batch list
    const getBatch = () => {
        db.collection('Batch')
            .where('type', '==', 'batch')
            .get()
            .then((querySnapshot) => {
                let data = querySnapshot.docs.map((doc) => ({
                    label: doc.data().batchName,
                    value: doc.data().itemID,
                }));
                setBatchList(data);
            });
    };

    // Fetch existing teacher data
    const getTeacherData = () => {
        if (!teacherId) return;
        db.collection('zSystemUsers')
            .doc(teacherId)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    const data = doc.data();
                    setValue('firstname', data.firstname);
                    setValue('lastname', data.lastname);
                    setValue('username', data.username);
                    setValue('email', data.email);
                    setValue('mobile', data.mobile);
                    setValue('password', data.password);
                    setSelectedBatches(data.isBatchManage || []);
                }
            })
            .catch((error) => {
                notify(error.toString(), true);
            });
    };

    useEffect(() => {
        getBatch();
        getTeacherData();
    }, [teacherId]);

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#272a3d' : 'black',
            padding: 10,
        }),
        control: () => ({
            display: 'none',
        }),
    };

    // Update teacher data
    const updateTeacher = (data) => {
        document.querySelector('#loading-indicator').style.display = 'flex';

        const updatedUserData = {
            firstname: data.firstname,
            lastname: data.lastname,
            mobile: data.mobile,
            email: data.email,
            username: data.username,
            password: data.password,
            permissions: teacherPermissions,
            isBatchManage: selectedBatches,
        };

        db.collection('zSystemUsers')
            .doc(teacherId)
            .update(updatedUserData)
            .then(() => {
                setUserData((prev) =>
                    prev.map((user) =>
                        user._uniqueID === teacherId ? { ...user, ...updatedUserData } : user
                    )
                );
                getUsers();
                onClick();
                document.querySelector('#loading-indicator').style.display = 'none';
                notify('Teacher Updated successfully', false);
            })
            .catch((error) => {
                document.querySelector('#loading-indicator').style.display = 'none';
                notify(error.toString(), true);
            });
    };

    return (
        <div className='content'>
            <Row>
                <Col md='12'>
                    <Card style={{ margin: 0 }}>
                        <CardHeader>
                            <h5 className='title'>Edit Teacher</h5>
                        </CardHeader>
                        <CardBody>
                            <form onSubmit={handleSubmit(updateTeacher)}>
                                <Row className='lg' md='1'>
                                    <Col className='lg' md='3'>
                                        <FormGroup>
                                            <label>First Name*</label>
                                            <input
                                                className='form-control'
                                                {...register('firstname', { required: true })}
                                                name='firstname'
                                                placeholder='First Name'
                                                type='text'
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='3'>
                                        <FormGroup>
                                            <label>Last Name*</label>
                                            <input
                                                className='form-control'
                                                {...register('lastname')}
                                                name='lastname'
                                                placeholder='Last Name'
                                                type='text'
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Username*</label>
                                            <input
                                                className='form-control'
                                                placeholder='Username'
                                                type='text'
                                                name='username'
                                                required
                                                {...register('username', {
                                                    required: true,
                                                    minLength: 6,
                                                })}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Email*</label>
                                            <input
                                                className='form-control'
                                                {...register('email')}
                                                name='email'
                                                placeholder='user@user.com'
                                                type='email'
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Password*</label>
                                            <div style={{ display: 'flex', alignItems: 'center',justifyContent:'end' }}>
                                                <input
                                                    className='form-control'
                                                    {...register('password', {
                                                        required: true,
                                                        minLength: 6,
                                                    })}
                                                    required
                                                    name='password'
                                                    type={showPassword ? 'text' : 'password'}
                                                    placeholder='Password'
                                                />
                                                <div
                                                    style={{
                                                        position: 'absolute',
                                                        paddingRight: '15px',
                                                        cursor: 'pointer',
                                                    }}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    <i className={`fa fa-eye${showPassword ? '-slash' : ''}`} aria-hidden='true'></i>
                                                </div>
                                            </div>
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col className='lg' md='6'>
                                        <FormGroup>
                                            <label>Mobile*</label>
                                            <input
                                                className='form-control'
                                                {...register('mobile', {
                                                    required: true,
                                                    minLength: 10,
                                                    maxLength: 10,
                                                    min: 6000000000,
                                                })}
                                                name='mobile'
                                                placeholder='Mobile'
                                                type='number'
                                                required
                                            />
                                        </FormGroup>
                                    </Col>
                                    <Col className='lg' md='6'>
                                        <FormGroup className='permissions-multiselect'>
                                            <label>Select Batch</label>
                                            <ReactMultiSelectCheckboxes
                                                styles={customStyles}
                                                options={batchList}
                                                value={batchList.filter(batch => selectedBatches.includes(batch.value))}
                                                onChange={(option) => {
                                                    setSelectedBatches(option.map(val => val.value));
                                                }}
                                            />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <div>
                                    <Button color='info' type='submit'>
                                        Update
                                    </Button>
                                    <Button onClick={onClick}>Back</Button>
                                </div>
                            </form>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default EditTeacher;
